import { render, staticRenderFns } from "./NegotiationsItem.vue?vue&type=template&id=932b7782&scoped=true&"
import script from "./NegotiationsItem.vue?vue&type=script&lang=js&"
export * from "./NegotiationsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932b7782",
  null
  
)

export default component.exports